// AUTO-GENERATED by tools/generate-bonus-levels.mjs. Do not edit by hand.
// Regenerate with: node tools/generate-bonus-levels.mjs
// Bonus pack — pearlescent interstitials that surface variable-ratio after
// a clean clear. Shallow (d=2-3), small boards (r=2), quick wins.
import type { LevelDef } from '@tessera/engine';

export const BONUS_LEVELS: LevelDef[] = [
  // d*=2  branching=8.06  D=0.061  tiles=6
  {
    id: 'bonus-01',
    world: 0,
    index: 1,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 4 },
    tiles: [
    { coord: { q: 0, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 0 }, color: 0 },
    { coord: { q: -1, r: -1 }, color: 0 },
    { coord: { q: -1, r: 2 }, color: 1 },
    { coord: { q: 1, r: 1 }, color: 1 },
    ],
  },
  // d*=3  branching=8.32  D=0.413  tiles=6
  {
    id: 'bonus-02',
    world: 0,
    index: 2,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: 2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 0 }, color: 0 },
    { coord: { q: -2, r: 1 }, color: 0 },
    { coord: { q: 2, r: 0 }, color: 1 },
    { coord: { q: 2, r: -2 }, color: 1 },
    ],
  },
  // d*=2  branching=8.66  D=0.066  tiles=6
  {
    id: 'bonus-03',
    world: 0,
    index: 3,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 4 },
    tiles: [
    { coord: { q: 0, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 0 },
    { coord: { q: -1, r: 2 }, color: 0 },
    { coord: { q: -2, r: 1 }, color: 1 },
    { coord: { q: -1, r: -1 }, color: 1 },
    ],
  },
  // d*=3  branching=8.32  D=0.413  tiles=6
  {
    id: 'bonus-04',
    world: 0,
    index: 4,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: -2, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 0 },
    { coord: { q: 0, r: 2 }, color: 0 },
    { coord: { q: -1, r: -1 }, color: 1 },
    { coord: { q: 0, r: -2 }, color: 1 },
    ],
  },
  // d*=2  branching=8.94  D=0.068  tiles=7
  {
    id: 'bonus-05',
    world: 0,
    index: 5,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 4 },
    tiles: [
    { coord: { q: 0, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -2 }, color: 0 },
    { coord: { q: -1, r: -1 }, color: 0 },
    { coord: { q: 1, r: -2 }, color: 0 },
    { coord: { q: 2, r: -1 }, color: 1 },
    { coord: { q: 1, r: 1 }, color: 1 },
    ],
  },
  // d*=3  branching=8.76  D=0.417  tiles=6
  {
    id: 'bonus-06',
    world: 0,
    index: 6,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: -1, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 1 }, color: 0 },
    { coord: { q: 2, r: 0 }, color: 0 },
    { coord: { q: 2, r: -2 }, color: 1 },
    { coord: { q: 0, r: -2 }, color: 1 },
    ],
  },
  // d*=2  branching=9.80  D=0.076  tiles=6
  {
    id: 'bonus-07',
    world: 0,
    index: 7,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 4 },
    tiles: [
    { coord: { q: 2, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 0 },
    { coord: { q: -2, r: 1 }, color: 0 },
    { coord: { q: 2, r: -1 }, color: 1 },
    { coord: { q: 2, r: -2 }, color: 1 },
    ],
  },
  // d*=3  branching=8.76  D=0.417  tiles=7
  {
    id: 'bonus-08',
    world: 0,
    index: 8,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: -2, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -1 }, color: 0 },
    { coord: { q: 2, r: 0 }, color: 0 },
    { coord: { q: 1, r: 1 }, color: 0 },
    { coord: { q: -2, r: 2 }, color: 1 },
    { coord: { q: 0, r: 2 }, color: 1 },
    ],
  },
  // d*=2  branching=10.20  D=0.079  tiles=6
  {
    id: 'bonus-09',
    world: 0,
    index: 9,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 4 },
    tiles: [
    { coord: { q: -1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -2 }, color: 0 },
    { coord: { q: 2, r: -2 }, color: 0 },
    { coord: { q: 0, r: 2 }, color: 1 },
    { coord: { q: 1, r: 1 }, color: 1 },
    ],
  },
  // d*=3  branching=9.16  D=0.420  tiles=7
  {
    id: 'bonus-10',
    world: 0,
    index: 10,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: 2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 0 }, color: 0 },
    { coord: { q: -2, r: 1 }, color: 0 },
    { coord: { q: -1, r: 0 }, color: 0 },
    { coord: { q: 2, r: -2 }, color: 1 },
    { coord: { q: 0, r: -2 }, color: 1 },
    ],
  },
  // d*=2  branching=10.58  D=0.083  tiles=6
  {
    id: 'bonus-11',
    world: 0,
    index: 11,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 4 },
    tiles: [
    { coord: { q: -2, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 1 }, color: 0 },
    { coord: { q: 0, r: 2 }, color: 0 },
    { coord: { q: -2, r: 2 }, color: 1 },
    { coord: { q: -2, r: 1 }, color: 1 },
    ],
  },
  // d*=3  branching=10.26  D=0.430  tiles=6
  {
    id: 'bonus-12',
    world: 0,
    index: 12,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: 2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 1 }, color: 0 },
    { coord: { q: -2, r: 2 }, color: 0 },
    { coord: { q: 2, r: -2 }, color: 1 },
    { coord: { q: 1, r: 1 }, color: 1 },
    ],
  },
  // d*=2  branching=10.58  D=0.083  tiles=6
  {
    id: 'bonus-13',
    world: 0,
    index: 13,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 4 },
    tiles: [
    { coord: { q: -2, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -2 }, color: 0 },
    { coord: { q: 2, r: -1 }, color: 0 },
    { coord: { q: 0, r: -2 }, color: 1 },
    { coord: { q: 1, r: -2 }, color: 1 },
    ],
  },
  // d*=3  branching=10.26  D=0.430  tiles=6
  {
    id: 'bonus-14',
    world: 0,
    index: 14,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: -2, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -1 }, color: 0 },
    { coord: { q: 1, r: 1 }, color: 0 },
    { coord: { q: -1, r: -1 }, color: 1 },
    { coord: { q: -2, r: 2 }, color: 1 },
    ],
  },
  // d*=2  branching=10.58  D=0.083  tiles=7
  {
    id: 'bonus-15',
    world: 0,
    index: 15,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 4 },
    tiles: [
    { coord: { q: 1, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 2 }, color: 0 },
    { coord: { q: 0, r: 2 }, color: 0 },
    { coord: { q: 2, r: 0 }, color: 0 },
    { coord: { q: 2, r: -1 }, color: 1 },
    { coord: { q: 2, r: -2 }, color: 1 },
    ],
  },
  // d*=3  branching=10.43  D=0.431  tiles=6
  {
    id: 'bonus-16',
    world: 0,
    index: 16,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: -2, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -2 }, color: 0 },
    { coord: { q: 2, r: -2 }, color: 0 },
    { coord: { q: 0, r: -2 }, color: 1 },
    { coord: { q: -2, r: 1 }, color: 1 },
    ],
  },
  // d*=2  branching=10.58  D=0.083  tiles=7
  {
    id: 'bonus-17',
    world: 0,
    index: 17,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 4 },
    tiles: [
    { coord: { q: 0, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -1 }, color: 0 },
    { coord: { q: -2, r: 0 }, color: 0 },
    { coord: { q: 1, r: -2 }, color: 0 },
    { coord: { q: 1, r: 1 }, color: 1 },
    { coord: { q: 2, r: 0 }, color: 1 },
    ],
  },
  // d*=3  branching=10.43  D=0.431  tiles=6
  {
    id: 'bonus-18',
    world: 0,
    index: 18,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: -2, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -2 }, color: 0 },
    { coord: { q: 2, r: -1 }, color: 0 },
    { coord: { q: 0, r: -2 }, color: 1 },
    { coord: { q: -2, r: 1 }, color: 1 },
    ],
  },
  // d*=2  branching=10.58  D=0.083  tiles=7
  {
    id: 'bonus-19',
    world: 0,
    index: 19,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 4 },
    tiles: [
    { coord: { q: 0, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -1 }, color: 0 },
    { coord: { q: -2, r: 0 }, color: 0 },
    { coord: { q: 1, r: -2 }, color: 0 },
    { coord: { q: -1, r: 2 }, color: 1 },
    { coord: { q: -2, r: 2 }, color: 1 },
    ],
  },
  // d*=3  branching=10.48  D=0.432  tiles=7
  {
    id: 'bonus-20',
    world: 0,
    index: 20,
    radius: 2,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: -1, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 0 },
    { coord: { q: 1, r: 1 }, color: 0 },
    { coord: { q: 2, r: -2 }, color: 0 },
    { coord: { q: -2, r: 0 }, color: 1 },
    { coord: { q: 1, r: -2 }, color: 1 },
    ],
  },
];
